<template>
    <div class="device-type-manange relative">
        <!-- 表单开始 -->
        <div class="buttons">
            <el-button :id="'doctorAdd'" @click="addData">新增</el-button>
        </div>
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="protocol_name" label="协议名称" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="role" label="前端" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="file_extend" label="文件类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="创建日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'doctorEdit'" v-if="scope.row.can_delete == 1" @click="deleteData(scope.row)"
                           type="text" size="mini">删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
            };
        },
        mounted() {
            // 获取协议列表
            this.getList();
            localStorage.setItem('prev_page', 'agreement_list')
        },
        methods: {
            // 获取所有协议
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'protocolList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].role) {
                            case '1':
                                res.data.data.list[i].role = '客户端';
                                res.data.data.list[i].role_number = 1;
                                break;
                            case '3':
                                res.data.data.list[i].role = '专家端';
                                res.data.data.list[i].role_number = 3;
                                break;
                        }
                        res.data.data.list[i].can_delete = parseInt(res.data.data.list[i].can_delete);
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 编辑
            goEdit(data) {

                this.$router.push({
                    name: "agreementEdit", params: {
                        id: data.id,
                        protocol_name: data.protocol_name,
                        content: data.content,
                        role: data.role_number,
                        file: data.protocol_file,
                    }
                });
            },

            addData() {
                this.$router.push({
                    name: "agreementAdd", params: {}
                });
            },

            deleteData(data) {

                this.$confirm('确定删除该协议吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_ContentServices',
                        method: 'deleteProtocol',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                    });
                }).catch(() => {
                });
            }

        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
